export default "__VITE_ASSET__BbvYf4EH__"